import { FC } from 'react';
import { ESize } from 'src/styles/theme/utils/enums';
import { StyledNGSpinner } from './NGSpinner.styles';
import { INGSpinner } from './NGSpinner.type';

const NGSpinner: FC<INGSpinner> = ({ size = ESize.m, isActivated = false, ...otherProps }) => {
	return <StyledNGSpinner spinnerSize={size} isActivated={isActivated} {...otherProps} />;
};

export { NGSpinner };
